var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0063ff",
    fillRule: "evenodd",
    d: "M3.107 5.554L12 11.779l8.893-6.225A1.006 1.006 0 0020 5H4c-.388 0-.728.227-.893.554zM3 7.92V18c0 .548.452 1 1 1h16c.548 0 1-.452 1-1V7.92l-8.427 5.9a1 1 0 01-1.146 0L3 7.92zm20-1.938V18c0 1.652-1.348 3-3 3H4c-1.652 0-3-1.348-3-3V5.982A3.006 3.006 0 014 3h16a3.006 3.006 0 013 2.983z"
  })));
}
export default SvgIconEmail;